// The awards landing banner: eyebrow, headline and the three headline counts.

import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useGetAllcountsQuery } from "../../services/rtkQueryServices/checkApiService";

const fmt = (n) => (n == null ? "-" : Number(n).toLocaleString());

const AwardsHero = () => {
  const { data } = useGetAllcountsQuery();
  const stats = [
    { label: "Total Awards", value: fmt(data?.unique_awards_count) },
    { label: "Honorific Awards", value: fmt(data?.aau_highly_prestigious_count) },
    { label: "Awardees", value: fmt(data?.unique_awardees_count) },
  ];
  return (
    <Box
      className="awards-hero"
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: "16px",
        p: { xs: 3, md: 4 },
        mb: 3,
        color: "#fff",
        background: (t) => `linear-gradient(135deg, ${t.palette.primary.main} 0%, ${t.palette.primary.dark} 100%)`,
        boxShadow: "0 10px 30px rgba(16,24,40,0.12)",
      }}
    >
      <Box aria-hidden sx={{ position: "absolute", top: -60, right: -40, width: 220, height: 220, borderRadius: "50%", bgcolor: "secondary.main", opacity: 0.18 }} />
      <Box sx={{ position: "relative" }}>
        {/* Two-tone eyebrow; the gap is a real space so it copies and reads aloud as two words. */}
        <Typography variant="overline" sx={{ letterSpacing: "0.18em", fontWeight: 700 }}>
          <Box component="span" sx={{ color: "secondary.main" }}>
            Scholars
          </Box>{" "}
          <Box component="span" sx={{ opacity: 0.72 }}>
            Awards Index
          </Box>
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 800, mt: 0.5, mb: 1.5, maxWidth: 720, lineHeight: 1.15 }}>
          Search awards, honorifics &amp; the people who earned them
        </Typography>
        <Stack direction="row" spacing={{ xs: 3, md: 5 }} flexWrap="wrap" rowGap={2}>
          {stats.map((s) => (
            <Box key={s.label}>
              <Typography sx={{ fontWeight: 800, fontSize: "1.9rem", lineHeight: 1 }}>{s.value}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.85, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                {s.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default AwardsHero;
